import { gql, useQuery } from '@apollo/client';

import { ignorePermissionsErrors } from 'src/lib/apollo/catchErrors';
import { appLinkContext } from 'src/lib/apollo/link';
import {
  UsePublishedSchemaQuery,
  UsePublishedSchemaQueryVariables,
} from 'src/lib/graphqlTypes/types';

import {
  determineGraphArchitecture,
  isPublished,
  publishSchemaGraphFragment,
} from './PublishYourSchema';

const usePublishedSchemaQuery = gql<
  UsePublishedSchemaQuery,
  UsePublishedSchemaQueryVariables
>`
  query UsePublishedSchemaQuery(
    $graphId: ID!
    $graphVariant: String!
    $noVariant: Boolean!
  ) {
    graph(id: $graphId) {
      id
      ...PublishSchemaGraphFragment
    }
  }
  ${publishSchemaGraphFragment}
`;

interface Props {
  graphId?: string;
  graphVariant?: string;
  pollForPublish?: boolean;
}

export const usePublishedSchema = ({
  graphId,
  graphVariant,
  pollForPublish = true,
}: Props) => {
  const queryResult = useQuery(usePublishedSchemaQuery, {
    pollInterval: pollForPublish ? 10000 : 0,
    variables: {
      graphId: graphId ?? '',
      graphVariant: graphVariant ?? '',
      noVariant: !graphVariant,
    },
    skip: !graphId,
    context: appLinkContext({ catchErrors: [ignorePermissionsErrors] }),
  });
  return {
    ...queryResult,
    architecture: determineGraphArchitecture(queryResult.data?.graph),
    published: Boolean(
      queryResult.data?.graph && isPublished(queryResult.data.graph),
    ),
  };
};
